<template>
    <div class="input-group"
         style="height:35px;">
        <span class="input-group-addon"
              v-if="label&&label.length>0"><span class="gray">{{label}}</span></span>
        <div class="fg-line"
             style="padding-top:7px;padding-bottom: 7px;"
             v-bind:style="{'pointer-events':isEnabled?'all':'none'}">
            <label class="m-b-0">
                <input type="checkbox"
                       value="1" /> &nbsp;{{text1}} &nbsp;
            </label>
            <label class="m-b-0">
                <input type="checkbox"
                       value="2" /> &nbsp;{{text2}} &nbsp;
            </label>
        </div>
    </div>
</template>

<script>
    import 'jquery.icheck';
    import 'jquery.icheck.css';
    export default{
        name: 'c-threecheckbox',
        data: function () {
            return {
                myValue: this.value
            };
        },
        props: {
            value: null,
            label: '',
            text1: {
                default: '无'
            },
            text2: {
                default: '有'
            },
            value1: {
                default: false
            },
            value2: {
                default: true
            },
            isEnabled: {
                default: true
            }
        },
        computed: {},
        watch: {
            'isEnabled': function (n) {
                if (n) {
                    $(this.$el).find(':checkbox').iCheck('enable');
                } else {
                    $(this.$el).find(':checkbox').iCheck('disable');
                }
            },
            'value': function (n) {
                if (n === this.value1) {
                    $(this.$el).find('input:last').iCheck('uncheck');
                    $(this.$el).find('input:first').iCheck('check');
                } else if (n === this.value2) {
                    $(this.$el).find('input:first').iCheck('uncheck');
                    $(this.$el).find('input:last').iCheck('check');
                } else {
                    $(this.$el).find('input:first').iCheck('uncheck');
                    $(this.$el).find('input:last').iCheck('uncheck');
                }
            },
            'myValue': function (value) {
                this.$emit('input', value);
            }
        },
        mounted: function () {
            var self = this;
            if (this.myValue === this.value1) {
                $(this.$el).find('input:last').iCheck('uncheck');
                $(this.$el).find('input:first').iCheck('check');
            } else if (this.myValue === this.value2) {
                $(this.$el).find('input:first').iCheck('uncheck');
                $(this.$el).find('input:last').iCheck('check');
            } else {
                $(this.$el).find('input:first').iCheck('uncheck');
                $(this.$el).find('input:last').iCheck('uncheck');
            }
            $(this.$el).find(':checkbox')
                .iCheck({ checkboxClass: 'icheckbox_flat-green p-relative' })
                .on('ifChanged', function () {
                    if ($(this).val() === '1') {
                        if ($(this).prop('checked')) {
                            $(self.$el).find('input:last').iCheck('uncheck');
                            self.myValue = self.value1;
                        } else {
                            self.myValue = null;
                        }
                    } else {
                        if ($(this).prop('checked')) {
                            $(self.$el).find('input:first').iCheck('uncheck');
                            self.myValue = self.value2;
                        } else {
                            self.myValue = null;
                        }
                    }
                })
                .on('ifClicked', function () {
                    $(this).parent().addClass('focus');
                    $(this).focus();
                });
        },
        methods: {}


    }

</script>



// WEBPACK FOOTER //
// threecheckbox.vue?5d4b39ab